var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7983 1.33488H27M3.54313 1.352L3.56022 1.33301M3.54313 11.5098L3.56022 11.4908M1.66666 21.3119L2.9177 22.6663L6.04526 19.2804M9.7983 11.4927H27M9.7983 21.6505H27",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location1.15637aef8076763082282cfd9a3642f5.svg";
export { ForwardRef as ReactComponent };